'use client';

import { useEffect } from 'react';
import * as rrd from 'react-router-dom';

const { useLocation } = rrd.default ?? rrd;

const CONVERTER_TAB_HASHES = new Set(['single', 'account', 'profile']);

function ScrollToTop() {
  const { hash, pathname } = useLocation();

  // Route navigation (path change) -> scroll to top
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  // Hash navigation (anchors) -> scroll to element
  useEffect(() => {
    if (!hash) return;

    const key = hash.replace('#', '').trim().toLowerCase();

    // Ignore tab hashes on the converter route
    if (pathname.startsWith('/convert') && CONVERTER_TAB_HASHES.has(key)) {
      return;
    }

    requestAnimationFrame(() => {
      const el = document.querySelector(hash);

      if (el) {
        el.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    });
  }, [hash, pathname]);

  return null;
}

export default ScrollToTop;
